import { Dayjs } from "dayjs";

export enum DeliveryReportStatus {
    PENDING = "pending",
    QUEUED = "queued",
    FAILED = "failed",
    SENT = "sent",
    UNDELIVERED = "undelivered",
    DELIVERED = "delivered",
    ERROR = "error",
    SUPPRESSED = "suppressed",
}

export enum DeliveryTransport {
    SMS = "sms",
    WHATSAPP = "whatsapp",
}

export enum DeliveryDirection {
    IN = "in",
    OUT = "out",
}

export interface DeliveryReport {
    object: "deliveryReport";
    id: ID;
    conversation: { id: ID };
    /** The embedded message's id. Messages have no collection of their own, so this is a string, not a reference. */
    message: ID;
    seller: { id: ID };
    /** The provider's own id. Null until the provider answers, which is how a failure short of it is identified. */
    remoteId: string | null;
    sentFrom: string | null;
    sentTo: string;
    /** E.164 digits without the plus, which is the shape a provider callback matches on. */
    sentToNormalized: string;
    transport: DeliveryTransport;
    direction: DeliveryDirection;
    /** What the provider charged, in USD. Null until reported. */
    cost: number | null;
    /** Segments billed. Null until reported: zero would report an in-flight message as free. */
    credits: number | null;
    error: string | null;
    status: DeliveryReportStatus;
    /** The provider's own event times. Older reports lack them. */
    queuedAt?: Dayjs | null;
    sentAt?: Dayjs | null;
    deliveredAt: Dayjs | null;
    createdAt: Dayjs;
    updatedAt: Dayjs;
}
